module.exports = __webpack_public_path__ + "static/img/image_we_06_01.8a7e39e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/home/image_we_06_01.png
// module id = xYdq
// module chunks = 10